import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import type { Feed, FeedSyncRunView, WebhookReplayResult, WordfenceStatus } from '@ametica/shared';
import { api } from './client';

export const WORDFENCE_KEY = ['wordfence'] as const;

/** Stav kľúča, katalógu a kvóty. Obnovuje sa každých 30 s — okno sa otvára samo, tlačidlo sa musí odomknúť. */
export function useWordfenceStatus() {
  return useQuery({ queryKey: WORDFENCE_KEY, queryFn: () => api<WordfenceStatus>('/wordfence/status'), refetchInterval: 30_000 });
}

/**
 * Ručný FeedSyncRun — míňa slot kvóty. Odmietnutie (409) príde ako ApiError so
 * správou, ktorá už obsahuje čas ďalšieho okna a zostatok.
 */
export function useSyncFeed() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (feed: Feed) => api<FeedSyncRunView>('/wordfence/sync', { method: 'POST', body: JSON.stringify({ feed }) }),
    onSettled: () => qc.invalidateQueries({ queryKey: WORDFENCE_KEY }),
  });
}

export function useResetBreaker() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: () => api<void>('/wordfence/breaker/reset', { method: 'POST' }),
    onSettled: () => qc.invalidateQueries({ queryKey: WORDFENCE_KEY }),
  });
}

/** Prehratie uloženého webhook eventu — tá istá cesta ako živý event, výsledok v odpovedi. */
export function useReplayWebhookEvent() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id: string) => api<WebhookReplayResult>(`/wordfence/webhook/events/${id}/replay`, { method: 'POST' }),
    onSettled: () => qc.invalidateQueries({ queryKey: WORDFENCE_KEY }),
  });
}
